/**
 * Centralized Wiki URLs for the application
 */
export const WIKI_URLS = {
    /** Main Wiki home page */
    HOME: 'https://wiki.syensqo.com/display/IC/Internal+ChatGPT+Home',
    /** Release notes page */
    RELEASE_NOTES: 'https://wiki.syensqo.com/pages/viewpage.action?pageId=899157532',
} as const;
